import { render, staticRenderFns } from "./NoticeDetails.vue?vue&type=template&id=c8e3fd48&scoped=true"
import script from "./NoticeDetails.vue?vue&type=script&lang=js"
export * from "./NoticeDetails.vue?vue&type=script&lang=js"
import style0 from "./NoticeDetails.vue?vue&type=style&index=0&id=c8e3fd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e3fd48",
  null
  
)

export default component.exports